import * as tslib_1 from "tslib";
import _ from 'lodash';
import { PlaceOrderUrl, GetOrdersUrl, CancelOrderUrl, ChangeOrderUrl } from '../constants';
import { transformForApi, transformFromApi, transformOrderForApi } from '..';
import dayjs from 'dayjs';
const httpOptions = {
    headers: { Accept: 'application/json' },
};
export const create = (api) => {
    return (orderDesc) => {
        const order = transformForApi(orderDesc);
        return api.authenticated().post(PlaceOrderUrl, order, httpOptions);
    };
};
export const change = (api) => {
    return (orderDesc) => {
        const order = transformOrderForApi(orderDesc);
        return api.authenticated().post(ChangeOrderUrl, order, httpOptions);
    };
};
export const cancel = (api) => {
    return (orderId, accountId) => {
        // might need to pass subaccountId, clientRefId params at some point: https://ny4staging.tradingblock.com/RestHub/swagger-ui#/Orders/CancelOrder
        const data = { orderId, accountId };
        return api.authenticated().post(CancelOrderUrl, data, httpOptions);
    };
};
export const getOrders = (api) => {
    return (options) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        // remove blockId from request & format dates dayjs(options.dateFrom).utc().toDate()
        const request = _.omit(options, ['blockId']);
        const optionValues = Object.assign({}, request, { dateFrom: request.dateFrom
                ? dayjs(request.dateFrom)
                    .utc()
                    .toDate()
                : undefined, dateTo: request.dateTo
                ? dayjs(request.dateTo)
                    .utc()
                    .toDate()
                : undefined });
        const apiResponse = yield api.authenticated().get(GetOrdersUrl, optionValues, httpOptions);
        return Object.assign({}, apiResponse, { payload: apiResponse.payload
                ? Object.assign({}, apiResponse.payload, { items: _.map(apiResponse.payload.items, transformFromApi) }) : undefined });
    });
};
export function order(api) {
    return (accountId, subaccountId) => ({
        change: (req) => tslib_1.__awaiter(this, void 0, void 0, function* () { return yield change(api)(req); }),
        create: (orderDesc) => tslib_1.__awaiter(this, void 0, void 0, function* () { return create(api)(Object.assign({}, orderDesc, { AccountId: accountId, kind: 'order' })); }),
        get: (request) => tslib_1.__awaiter(this, void 0, void 0, function* () { return getOrders(api)(Object.assign({}, request, { accountId, subaccountId })); }),
        cancel: (orderId) => tslib_1.__awaiter(this, void 0, void 0, function* () { return cancel(api)(orderId, accountId); }),
    });
}
//# sourceMappingURL=orderApi.js.map